<main class="o-layout__wrapper">
  <svg
    width="74px"
    height="109px"
    viewBox="53 36 74 109"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs></defs>
    <path
      d="M90.3915,36 L95.4215,44.711 C96.4545,46.503 96.4545,48.729 95.4215,50.519 L65.5685,102.227 L79.6575,126.623 C81.8655,130.447 85.9635,132.824 90.3845,132.824 C94.8055,132.824 98.9225,130.447 101.1315,126.624 L115.2185,102.227 L111.4125,95.639 L95.4245,123.334 C94.3905,125.127 92.4415,126.236 90.3905,126.236 C88.3395,126.236 86.3985,125.127 85.3655,123.334 L73.1825,102.225 L100.9025,54.203 L105.9315,62.914 C106.9655,64.708 106.9655,66.933 105.9315,68.724 L86.5885,102.227 L90.3925,108.819 L111.4125,72.407 L125.2015,96.287 C127.3145,99.953 127.3145,104.506 125.2015,108.167 L111.1905,132.433 C109.0425,136.152 102.4105,144.443 90.3725,144.443 C78.3355,144.443 71.7435,136.152 69.5975,132.433 L55.5855,108.171 C53.4715,104.503 53.4715,99.952 55.5855,96.291 L90.3915,36"
      id="Fill-90"
      stroke="0"
      fill-rule="evenodd"
      fill="#E81C1C"
    ></path>
  </svg>
  <h2 class="message">Switching account, please hold on</h2>
</main>
